import { useEffect, useState } from "react";
import api from "@/lib/api";
import SiteEditor from "./SiteEditor";

export default function SitesTab() {
  const [sites, setSites] = useState(null);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/hs/sites").then(r => setSites(r.data));
  useEffect(() => { load(); }, []);
  if (sel) return <SiteEditor pid={sel} onClose={() => { setSel(null); load(); }}/>;
  if (!sites) return <div className="opacity-70">Loading…</div>;
  return (
    <div className="card overflow-x-auto" data-testid="hs-sites-list">
      <table className="table w-full text-sm">
        <thead><tr><th>Project</th><th>Site code</th><th>Site details</th><th>Top hazards</th><th></th></tr></thead>
        <tbody>
          {sites.map(s => (
            <tr key={s.id} data-testid={`hs-site-row-${s.id}`}>
              <td>{s.name}<div className="text-xs opacity-60">{s.address}</div></td>
              <td className="font-mono tracking-widest" data-testid={`hs-site-code-${s.id}`}>{s.site_code}</td>
              <td>{s.configured ? <span className="text-green-400">Set up</span> : <span className="text-amber-400">Needs details</span>}</td>
              <td>{s.top_count} / 8</td>
              <td><button className="btn-ghost text-sm" onClick={() => setSel(s.id)} data-testid={`hs-site-edit-${s.id}`}>Edit</button></td>
            </tr>
          ))}
          {sites.length === 0 && <tr><td colSpan={5} className="opacity-60">No open projects.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
